<template>
    <div class="cps-main-page">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item><i class="el-icon-s-home"></i>首页</el-breadcrumb-item>
            <el-breadcrumb-item>礼包管理</el-breadcrumb-item>
            <el-breadcrumb-item>注册抽奖</el-breadcrumb-item>
        </el-breadcrumb>
        <el-divider></el-divider>
        <div class="page-content">
            <el-row @keyup.enter.native="loadData(1)">
                <el-input v-model="queryField.drawId" size="small" placeholder="id"></el-input>
                <el-input v-model="queryField.adminId" size="small" placeholder="管理员id"></el-input>
                <el-input v-model="queryField.nickName" size="small" placeholder="微信昵称"></el-input>
                <el-input v-model="queryField.userName" size="small" placeholder="玩家账号"></el-input>
                <el-select v-model="queryField.isLottery" placeholder="是否开奖">
                    <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <el-select v-model="queryField.prizeType" placeholder="中奖类型">
                    <el-option
                        v-for="item in prizeType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <el-select v-model="queryField.sendState" placeholder="发放状态">
                    <el-option
                        v-for="item in sendState"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <el-button  type="primary" icon="el-icon-search" size="small" @click="loadData(1)">查询</el-button>
                <el-button  type="primary" icon="el-icon-refresh" size="small" @click="reset">重置</el-button>
                <el-button  type="primary" icon="el-icon-plus" size="small" @click="$router.push({name: 'RegisterDrawAdd'})" v-if="showAddPreset">添加预设</el-button>
            </el-row>
            <el-table class="cps-table-data"
                      v-loading="loading"
                      :data="tableData" size="small"
                      border
                      :height="height"
                      style="width: 100%">
                <el-table-column
                    prop="id"
                    label="id"
                    width="80">
                </el-table-column>
                <el-table-column
                    prop="admin_id"
                    label="管理员id"
                    width="80">
                </el-table-column>
                <el-table-column
                        v-if="false"
                    prop="openid"
                    label="微信唯一标志"
                    width="120">
                </el-table-column>
                <el-table-column
                    prop="head_img"
                    label="微信头像"
                    width="70">
                    <template slot-scope="scope">
                        <el-avatar shape="square" :src="scope.row.head_img" />
                    </template>
                </el-table-column>
                <el-table-column
                    prop="nick_name"
                    label="微信昵称"
                    width="120">
                </el-table-column>
                <el-table-column
                    prop="user_name"
                    label="玩家账号"
                    width="120">
                </el-table-column>
                <el-table-column
                    prop="isLottery"
                    label="是否开奖"
                    :formatter="routineFormat" 
                    width="80">
                </el-table-column>
                <el-table-column
                    prop="prize_name"
                    label="奖品名"
                    width="120">
                </el-table-column>
                <el-table-column
                    prop="prize_type"
                    label="中奖类型"
                    :formatter="prizeTypeFormat"
                    width="80">
                </el-table-column>
                <el-table-column
                    prop="cdk"
                    label="兑换码"
                    width="120">
                </el-table-column>
                <el-table-column
                    prop="send_state"
                    label="发放状态"
                    :formatter="sendStateFormat"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="fail_msg"
                    label="发放失败原因"
                    :show-overflow-tooltip="true"
                    width="200">
                </el-table-column>
                <el-table-column
                    prop="draw_time"
                    label="开奖时间"
                    width="140">
                </el-table-column>
                <el-table-column
                    label="操作"
                    v-if="showAudit">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" 
                                   v-if="audit(scope.row.audit_flag,scope.row.prize_type,scope.row.send_state,scope.row.preset_prize)"
                                   @click="passed(scope.row.id)">通过审核</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination  class="cps-table-data"
                            @current-change="loadData"
                            background
                            :page-size="15"
                            layout="total, prev, pager, next"
                            :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import {getPageButtons, passedAudit, queryRegisterDraw} from "@/api/request";

export default {
    name: "registerDraw",
    data(){
        return {
            currentIndex: "",
            pageSize: 15,
            total: 0,
            height: window.innerHeight - 210,
            loading: true,
            showAudit: false,
            showAddPreset: false,
            options:[
                {value:0,label:"否"},
                {value:1,label:"是"}
            ],
            prizeType:[
                {value: 1,label: "桃花币"},
                {value: 2,label: "红包"},
                {value: 3,label: "游戏礼包"}
            ],
            sendState:[
                {value: 0,label: "未发放"},
                {value: 1,label: "发放成功"},
                {value: 2,label: "发放失败"}
            ],
            queryField:{
                drawId:"",
                adminId:"",
                nickName:"",
                userName:"",
                isLottery: "",
                prizeType: "",
                sendState:"",
            },
            tableData:[]
        }
    },
    mounted() {
        this.loadData(1);
        this.getPageButtons()
    },
    methods:{
        getPageButtons() {
            let path = this.$route.path.replace("/", "");
            getPageButtons(path).then(res => {
                if (res.data.success) {
                    let menuCodes = res.data.data;
                    this.showAudit = menuCodes.includes("register_draw_audit");
                    this.showAddPreset = menuCodes.includes("register_draw_add");
                } else {
                    this.$message.error(res.data.error.message);
                }
            });
        },
        loadData(index){
            let params = {
                pageNo: index,
                pageSize: this.pageSize,
                params: this.queryField
            }
            queryRegisterDraw(params).then(res => {
                this.tableData = res.data.list
                this.currentIndex = index;
                this.total = res.data.total;
                this.loading = false;
            })
        },
        passed(id){
            passedAudit(id).then(res => {
                if(res.data.success){
                    this.$message.success("操作成功");
                    this.loadData(this.currentIndex);
                }else {
                    this.$message.error(res.data.error.message);
                }
            })
        },
        audit(auditFlag,prizeType,sendState,presetPrize){
            return auditFlag === 0 && this.showAudit && sendState !== 1 && presetPrize == null
                   && prizeType !== 36 && prizeType !== 37 && prizeType !== 38 && prizeType !== '' && prizeType != null;
        },
        reset(){
            this.queryField = {
                adminId:"",
                userId:"",
                userName:"",
                isLottery: "",
                prizeType: "",
                auditFlag: ""
            }
            this.loadData(1);
        },
        routineFormat(row, column, cellValue){
            let rep = "";
            if(cellValue === 0){
                rep = "否";
            }else if(cellValue === 1){
                rep = "是";
            }
            return rep;
        },
        prizeTypeFormat(row, column, cellValue){
            let rep = "";
            if(cellValue === 42 || cellValue == 43 | cellValue === 44){
                rep = "桃花币";
            }else if(cellValue === 39 || cellValue === 40 || cellValue === 41){
                rep = "现金红包";
            }else if(cellValue === 36 || cellValue === 37 || cellValue === 38){
                rep = "游戏礼包"
            }
            return rep;
        },
        sendStateFormat(row, column, cellValue){
            let rep = "";
            if(cellValue === 0){
                rep = "未发放";
            }else if(cellValue === 1){
                rep = "发放成功";
            }else if(cellValue === 2){
                rep = "发放失败"
            }
            return rep;
        }
    }
}
</script>

<style scoped>

</style>